import type { BotUsageData } from '@common-reducers/backend-api/backend-api';

/** The section names agents when every entry is an agent (Agents 2.0 accounts with no legacy bots). */
export const isAllAgents = (entries: readonly BotUsageData[]): boolean =>
    entries.length > 0 && entries.every((e) => e.kind === 'agent');

/** Estimated-but-uncharged credits worth mentioning (shown as "N not charged"); 0 = say nothing. */
export const notChargedCredits = (entry: Partial<BotUsageData> | undefined): number => {
    const n = Number(entry?.estimatedCredits ?? 0);
    return Number.isFinite(n) && n > 0 ? n : 0;
};
